import { createGlobalStyle } from "styled-components";

export const AppGlobalStyles = createGlobalStyle`
  #root {
    height: 100%;
  }
`;
